import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../core/service/auth.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { finalize, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  loading: boolean;
  forgotPasswordForm: FormGroup;

  constructor(
    private authService: AuthService,
    public toastr: ToastrManager,
    private router: Router
  ) { }

  ngOnInit() {
    this.createForgotPasswordForm();
  }

  forgotPasswordSubmit() {
    this.loading = true;
    const email = this.forgotPasswordForm.value.email;
    this.authService.resetPassword(email)
      .pipe(
        finalize(() => {
          this.loading = false;
        }),
        catchError(err => {
          this.toastr.errorToastr(err.message);
          this.loading = false;
          return of([]);
        }),
      )
      .subscribe((response) => {
        if (!response) {
          this.toastr.successToastr(`New password was sent to ${email}`);
          this.router.navigate(['/login']);
        }
        this.loading = false;
      });
  }

  createForgotPasswordForm() {
    this.forgotPasswordForm = new FormGroup({
      email: new FormControl('', {validators: [Validators.required, Validators.email]})
    });
  }

}
